import PropTypes from 'prop-types';

// Convert a "camelCased" string to "kebab-case"
export function camelCaseToKebabCase(str) {
  if (!str) {
    return '';
  }
  return str.replace(/([a-zA-Z])(?=[A-Z])/g, '$1-').toLowerCase();
}

// Convert a "snake_cased" string to "kebab-case"
export function snakeToKebab(str) {
  return str.replace(/_/g, '-');
}

// Convert a "snake_cased" string to "PascalCase"
export function snakeCaseToPascalCase(snakeStr) {
  return snakeStr
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join('');
}

/**
 * Escapes special characters from the input string.
 *
 * @param {string} str - The string to be escaped.
 * @returns {string} - The string with special characters removed.
 */
export const escapeSpecialCharacters = (str) => {
  if (!str.length) {
    return '';
  }
  const regex = /[^\p{L}\p{M}\p{N}\p{Zs},.;:!?'"-a-zA-Z0-9_:\s]/gu;
  return str.replace(regex, '');
};
escapeSpecialCharacters.propTypes = {
  str: PropTypes.string
};
